import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { NotFoundComponent } from './errors/not-found/not-found.component';
import { HomeComponent } from './home/home.component';
import { AuthGuard } from './seguranca/auth.guard';
import { ProcedimentoComponent } from './procedimento/procedimento.component';
import { PrestadorComponent } from './prestador/prestador.component';
import { UsuarioComponent } from './usuario/usuario.component';
import { ForbiddenComponent } from './errors/forbidden/forbidden.component';
import { AtendimentoComponent } from './core/atendimento/atendimento.component';
import { CadastroAtendimentoComponent } from './core/atendimento/cadastro/cadastro-atendimento.component';
import { DetalheAtendimentoComponent } from './core/atendimento/detalhe/detalhe-atendimento.component';
import { NovaSenhaComponent } from './core/nova-senha/nova-senha.component';
import { PrestadorProcedimentoComponent } from './prestador/prestador-procedimentos/prestador-procedimento.component';
import { EstatisticasComponent } from './estatisticas/estatisticas.component';
import { RelatorioComponent } from './relatorio/relatorio.component';
import { DependenteComponent } from './dependente/dependente.component';

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'login',
        data: {
          title: 'Assistência Médica Moura',
      }
    },
    {
      path: 'nova-senha/:token',
      component: NovaSenhaComponent,
      data: {
          title: 'Assistência Médica Moura - Nova Senha',
      }
    },
    {
        path: 'home',
        component: HomeComponent,
        canActivate: [ AuthGuard ],
        data: {
            title: 'Assistência Médica Moura - Home',
            roles: ['CONSULTAR_GRAFICOS']
        }
    },
    {
      path: 'atendimentos',
      component: AtendimentoComponent,
      canActivate: [ AuthGuard ],
      data: {
          title: 'Assistência Médica Moura - Atendimentos',
          roles: ['CONSULTAR_ATENDIMENTOS']
      },
    },
    {
      path: 'atendimentos/new',
      component: CadastroAtendimentoComponent,
      canActivate: [ AuthGuard ],
      data: {
          title: 'Assistência Médica Moura - Cadastro',
          roles: ['EDITAR_ATENDIMENTOS']
      }
    },
    {
      path: 'atendimentos/edit/:guiaId',
      component: CadastroAtendimentoComponent,
      canActivate: [AuthGuard],
      data: {
        title: 'Assistência Médica Moura - Edição',
        roles: ['EDITAR_ATENDIMENTOS']
      }
    },
    {
      path: 'atendimentos/view/:guiaId',
      component: DetalheAtendimentoComponent,
      canActivate: [AuthGuard],
      data: {
        title: 'Assistência Médica Moura - Detalhe',
        roles: ['CONSULTAR_ATENDIMENTOS']
      }
    },
    {
      path: 'procedimentos',
      component: ProcedimentoComponent,
      canActivate: [ AuthGuard ],
      data: {
          title: 'Assistência Médica Moura - Procedimentos',
          roles: ['EDITAR_PROCEDIMENTOS']
      }
    },
    {
      path: 'prestadores',
      canActivate: [AuthGuard],
      data: {
        title: 'Assistência Médica Moura - Prestadores',
        roles: ['EDITAR_PRESTADORES']
      },
      children: [
          { path: '', component: PrestadorComponent },
          { path: ':prestadorId/procedimentos', component: PrestadorProcedimentoComponent }
      ]
    },
    {
      path: 'usuarios',
      component: UsuarioComponent,
      canActivate: [ AuthGuard ],
      data: {
          title: 'Assistência Médica Moura - Usuários',
          roles: ['EDITAR_USUARIOS']
      }
    },
    {
      path: 'estatisticas',
      component: EstatisticasComponent,
      canActivate: [ AuthGuard ],
      data: {
          title: 'Assistência Médica Moura - Estatísticas',
          roles: ['CONSULTAR_GRAFICOS_ADMINISTRATIVOS']
      }
    },
    {
      path: 'relatorio',
      component: RelatorioComponent,
      canActivate: [ AuthGuard ],
      data: {
          title: 'Assistência Médica Moura - Relatório HCM',
          roles: ['CONSULTAR_GRAFICOS_ADMINISTRATIVOS', 'CONSULTAR_RELATORIO_ADMINISTRATIVO']
      }
    },
    {
      path: 'dependente',
      component: DependenteComponent,
      canActivate: [ AuthGuard ],
      data: {
          title: 'Assistência Médica Moura - Dependente',
          roles: ['EDITAR_USUARIOS']
      }
    },
    {
      path: 'not-found',
      component: NotFoundComponent,
      data: {
          title: 'Página não encontrada'
      }
    },
    {
      path: 'nao-autorizado',
      component: ForbiddenComponent,
      data: {
          title: 'Acesso Negado'
      }
    },
    {
      path: '**',
      redirectTo: 'not-found'
    }
];

@NgModule({
    imports: [ RouterModule.forRoot(routes, { useHash: true }) ],
    // imports: [ RouterModule.forRoot(routes) ],
    exports: [ RouterModule ]
})
export class AppRoutingModule { }

